import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { endpointMap } from "../../../data/Fields";
import { toast } from "react-toastify";

export const createProperty = createAsyncThunk(
  "property/createProperty",
  async ({ data, propertyType, token, navigate }, { rejectWithValue }) => {
    const endpointType = endpointMap[propertyType];
    if (!endpointType) {
      return rejectWithValue("Неизвестный тип недвижимости");
    }

    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/property/create?property_type=${endpointType}`;

    try {
      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (!response.ok) {
        if (response.status === 413) {
          toast.error("Ошибка при заполнении или слишком большой файл");
          return rejectWithValue(
            "Ошибка при заполнении или слишком большой файл",
          );
        }

        if (response.status === 400) {
          toast.error("Ошибка");
          return rejectWithValue("Ошибка");
        }

        if (response.status === 401) {
          toast.error("Авторизация истекла. Пожалуйста, войдите заново.");
          navigate("/login");
          return rejectWithValue("Неавторизован");
        }
      }

      const result = await response.json();
      return result;
    } catch (error) {
      console.log(error);
      toast(error);
      return rejectWithValue(error.error);
    }
  },
);

export const updateProperty = createAsyncThunk(
  "property/updateProperty",
  async (
    { data, propertyType, propertyId, token, navigate },
    { rejectWithValue },
  ) => {
    // Формируем URL в соответствии с вашим API, например:
    // localhost:8080/api/v1/property/update_property/Commercial/19
    const endpoint = `${process.env.REACT_APP_API_URL}/api/v1/property/update_property/${propertyType}/${propertyId}`;
    try {
      const response = await fetch(endpoint, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (!response.ok) {
        if (response.status === 413 || response.status === 400) {
          toast.error("Ошибка при заполнении или слишком большой файл");
          return rejectWithValue(
            "Ошибка при заполнении или слишком большой файл",
          );
        }

        if (response.status === 401) {
          toast.error("Авторизация истекла. Пожалуйста, войдите заново.");
          navigate("/login");
          return rejectWithValue("Неавторизован");
        }

        const errorData = await response.json();
        console.log(response.status, errorData);
        return rejectWithValue(
          errorData.error || "Ошибка при обновлении объекта",
        );
      }

      const result = await response.json();
      return result;
    } catch (error) {
      return rejectWithValue(error.error);
    }
  },
);

const addObjectSlice = createSlice({
  name: "property",
  initialState: {
    loading: false,
    error: null,
    success: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createProperty.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(createProperty.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(createProperty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateProperty.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = null;
      })
      .addCase(updateProperty.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload;
      })
      .addCase(updateProperty.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default addObjectSlice.reducer;
